function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Autosuggest from 'react-autosuggest';
import cn from 'classnames';
import filter from 'lodash/filter';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
class AutosuggestInput extends (_React_PureComponent = React.PureComponent) {
    onSuggestionsFetchRequested({ value }) {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    }
    onSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }
    getSuggestions(value) {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        return inputLength === 0 ? [] : filter(this.props.suggestions, (suggestion)=>suggestion.name.toLowerCase().slice(0, inputLength) === inputValue);
    }
    getSuggestionValue(suggestion) {
        return suggestion.name;
    }
    renderPlaceholder() {
        if (!this.props.placeholder) {
            return null;
        }
        return isObjectLike(this.props.placeholder) ? this.props.intl.formatMessage(this.props.placeholder, _object_spread({}, this.props.placeholder.values)) : this.props.placeholder;
    }
    renderSuggestion(suggestion) {
        return /*#__PURE__*/ _jsx("div", {
            children: suggestion.name
        });
    }
    render() {
        const inputProps = _object_spread_props(_object_spread({
            id: this.props.id,
            value: this.props.value,
            type: 'text',
            className: cn('form-control', {
                'border-danger': this.props.hasError
            }, this.props.className),
            disabled: this.props.isDisabled,
            placeholder: this.renderPlaceholder()
        }, this.props.attributes), {
            onChange: (evt, { newValue })=>this.props.onChange({
                    id: this.props.id,
                    value: newValue
                }),
            onBlur: (evt)=>this.props.onBlur({
                    id: this.props.id,
                    value: evt.target.value
                })
        });
        return /*#__PURE__*/ _jsx(Autosuggest, {
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: (suggestion)=>this.onSuggestionsFetchRequested(suggestion),
            onSuggestionsClearRequested: ()=>this.onSuggestionsClearRequested(),
            getSuggestionValue: this.getSuggestionValue,
            renderSuggestion: this.renderSuggestion,
            inputProps: inputProps
        });
    }
    constructor(props){
        super(props);
        this.state = {
            suggestions: []
        };
    }
}
_define_property(AutosuggestInput, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    placeholder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    attributes: PropTypes.object,
    suggestions: PropTypes.array,
    hasError: PropTypes.bool,
    isDisabled: PropTypes.bool,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    // Implicit props
    intl: intlShape.isRequired
});
_define_property(AutosuggestInput, "defaultProps", {
    value: '',
    className: '',
    attributes: {},
    hasError: false,
    isDisabled: false,
    onBlur: ()=>{}
});
export default injectIntl(AutosuggestInput);
